import { Fragment } from "react";
import { Link } from "react-router-dom";

export const Solution = () => (
  // <Fragment>
  //   <li>
  //     <Link to="/AI-Accounting-Finance">Accounting & Finance</Link>
  //   </li>
  //   <li>
  //    <Link to="/AI-Human-Resources">Human Resources</Link>
  //   </li>
  //   <li>
  //     <Link to="/AI-Operations">Operations</Link>
  //   </li>
  //   <li>
  //      <Link to="/AI-Audit-Compliance">Audit & Compliance</Link>
  //   </li>
  // </Fragment>

  <Fragment>
    <li className="menu-dropdown-wrapper">
      <div className="dropdown-two-col">
        {/* LEFT */}
        <div className="dropdown-col">
          <div className="dropdown-heading pt-2 pt-md-0">
            AI WhatsApp Agents
          </div>

          <ul>
            <li>
              <Link to="/wa-food-ordering" className="dropdown-link">
                Food Ordering
              </Link>
            </li>
            <li>
              <Link to="/wa-invoice" className="dropdown-link">
                Accounting
              </Link>
            </li>
            <li>
              <Link to="/wa-attendance" className="dropdown-link">
                Attendance Tracking
              </Link>
            </li>
            <li>
              <Link to="/wa-chatbot" className="dropdown-link cb">
                Chatbot
              </Link>
            </li>
            <li>
              <Link to="/wa-grocery-ordering" className="dropdown-link">
                Grocery Ordering
              </Link>
            </li>
          </ul>
        </div>
        <div className="dropdown-col">
          <div className="dropdown-heading mt-2 mt-md-0">AI Agents</div>

          <ul>
            {/* <li>
              <Link to="/azure-ai-services" className="dropdown-link">
                AI Agents
              </Link>
            </li> */}
            <li>
              <Link to="/sor" className="dropdown-link">
                AI SOR Search
              </Link>
            </li>
            <li>
              <Link to="/ai-invoice" className="dropdown-link">
                AI Invoice Data Capture
              </Link>
            </li>
            {/* <li>
              <Link to="/inspection-photo" className="dropdown-link">
                AI Inspection App
              </Link>
            </li> */}
            <li>
              <Link to="/image-extract" className="dropdown-link">
                AI Image Data Extract
              </Link>
            </li>
          </ul>
        </div>
        {/* DIVIDER */}
        <div className="dd-divider"></div>

        {/* RIGHT */}
        <div className="dropdown-col">
          <div className="dropdown-heading pt-2 pt-md-0">RPA</div>

          <ul>
            <li>
              <Link to="/AI-Accounting-Finance" className="dropdown-link">
                Accounting & Finance
              </Link>
            </li>

            <li>
              <Link to="/AI-Human-Resources" className="dropdown-link">
                Human Resources
              </Link>
            </li>

            <li>
              <Link to="/AI-Operations" className="dropdown-link">
                Operations
              </Link>
            </li>

            <li>
              <Link to="/AI-Audit-Compliance" className="dropdown-link">
                Audit & Compliance
              </Link>
            </li>
          </ul>
        </div>
        <div className="dropdown-col">
          <div className="dropdown-heading pt-2 pt-md-0">INDUSTRIES</div>

          <ul>
            <li>
              <Link to="/wa-food-ordering" className="dropdown-link">
                F & B
              </Link>
            </li>
            <li>
              <Link to="/wa-attendance" className="dropdown-link">
                Construction
              </Link>
            </li>
            <li>
              <Link to="/wa-invoice" className="dropdown-link">
                Education
              </Link>
            </li>
            <li>
              <Link to="/wa-chatbot" className="dropdown-link cb">
                Manufacturing
              </Link>
            </li>
            <li>
              <Link to="/wa-grocery-ordering" className="dropdown-link">
                Retail
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </li>
  </Fragment>
);
export const Services = () => (
  <Fragment>
    {/* <li><Link to="/services">Services</Link></li> */}
    <li>
      <Link to="/Whatsapp-estore">AI WhatsApp Agents</Link>
    </li>
    <li>
      <Link to="/RPA-AI">RPA</Link>
    </li>
    <li>
      <Link to="/Data-Analytics">Data & Analytics</Link>
    </li>

    {/* <li>
      <Link to="/digital-consultancy">Digital Consulting</Link>
    </li>
    <li>
      <Link to="/Web-Development">Web Development</Link>
    </li> */}
  </Fragment>
);
// export const Projects = () => (
//   <Fragment>
//     <li className="menu-dropdown-wrapper">
//       <div className="dropdown-two-col">
//         {/* LEFT */}
//         <div className="dropdown-col">
//           <div className="dropdown-heading pt-2 pt-md-0">AI - WHATSAPP</div>

//           <ul>
//             <li>
//               <Link to="/wa-food-ordering" className="dropdown-link">
//                 Food Ordering
//               </Link>
//             </li>
//             <li>
//               <Link to="/wa-invoice" className="dropdown-link">
//                 Invoice Automation
//               </Link>
//             </li>
//             <li>
//               <Link to="/wa-attendance" className="dropdown-link">
//                 Attendance Tracking
//               </Link>
//             </li>
//             <li>
//               <Link to="/wa-chatbot" className="dropdown-link cb">
//                 Chatbot
//               </Link>
//             </li>
//           </ul>
//         </div>

//         {/* DIVIDER */}
//         <div className="dd-divider"></div>

//         {/* RIGHT */}
//         <div className="dropdown-col">
//           <div className="dropdown-heading">AI</div>

//           <ul>
//             <li>
//               <Link to="/azure-ai-services" className="dropdown-link">
//                 AI Agents
//               </Link>
//             </li>
//             <li>
//               <Link to="/sor" className="dropdown-link">
//                 AI SOR Search
//               </Link>
//             </li>
//             <li>
//               <Link to="/ai-invoice" className="dropdown-link">
//                 AI Invoice Data Capture
//               </Link>
//             </li>
//             <li>
//               <Link to="/inspection-photo" className="dropdown-link">
//                 AI Inspection App
//               </Link>
//             </li>
//             <li>
//               <Link to="/image-extract" className="dropdown-link">
//                 AI Image Data Extract
//               </Link>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </li>
//   </Fragment>
// );

export const News = () => (
  <Fragment>
    <li className="menu-dropdown-wrapper">
      <div className="dropdown-two-col">
        {/* LEFT */}
        <div className="dropdown-col">
          <div className="dropdown-heading pt-2 pt-md-0">TRAINING</div>

          <ul>
            <li>
              <Link to="/Rpa-training" className="dropdown-link">
                RPA
              </Link>
            </li>
            <li>
              <Link to="/python" className="dropdown-link">
                Python & SQL
              </Link>
            </li>
            <li>
              <Link to="/cloud" className="dropdown-link">
                Python Data Science
              </Link>
            </li>
            <li>
              <Link to="/Data-engineering-course" className="dropdown-link">
                Cloudera Data Engineer
              </Link>
            </li>
            <li>
              <Link to="/Data-analyst" className="dropdown-link">
                Cloudera Data Analyst
              </Link>
            </li>
            <li>
              <Link to="/AI" className="dropdown-link">
                Cloudera AI
              </Link>
            </li>
            <li>
              <Link to="/Machine-Learning" className="dropdown-link">
                Cloudera ML
              </Link>
            </li>
          </ul>
        </div>

        {/* DIVIDER */}
        <div className="dd-divider"></div>

        {/* RIGHT */}
        <div className="dropdown-col">
          <div className="dropdown-heading pt-2 pt-md-0">E-LEARNING</div>

          <ul>
            <li>
              <a
                href="https://ai.siw.sg/"
                target="_blank"
                rel="noopener noreferrer"
                className="dropdown-link"
              >
                Azure AI Engineer
              </a>
            </li>
            <li>
              <Link to="/CDE-Intro" className="dropdown-link">
                Cloudera Data Engineer
              </Link>
            </li>
            <li>
              <Link to="/hive" className="dropdown-link">
                Cloudera Data Analyst
              </Link>
            </li>
            <li>
              <Link to="/CAI-Intro" className="dropdown-link">
                Cloudera AI
              </Link>
            </li>
            <li>
              <Link to="#" className="dropdown-link">
                Cloudera ML
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </li>
  </Fragment>
);
// export const Learning = () => (
//   <Fragment>
//     <li>
//       <a href="https://ai.siw.sg/" target="_blank" rel="noopener noreferrer">
//         Azure AI Engineer
//       </a>
//     </li>
//     <li>
//       <Link to="/CDE-Intro">Cloudera Data Engineer</Link>
//     </li>
//     <li>
//       <Link to="/hive">Cloudera Data Analyst</Link>
//     </li>
//     <li>
//       <Link to="/CAI-Intro">Cloudera AI</Link>
//     </li>
//     <li>
//       <Link to="#">Cloudera ML</Link>
//     </li>
//   </Fragment>
// );